import { forwardRef } from 'react';

import { css } from '@emotion/css';
import { Segmented as AntdSegmented, SegmentedProps } from 'antd';

export const getHeight = (size?: 'small' | 'default' | 'large') => {
  switch (size) {
    case 'small':
      return 24;
    case 'large':
      return 36;
    default:
      return 32;
  }
};

export const getStyle = (size?: 'small' | 'default' | 'large') => {
  switch (size) {
    case 'small':
      return css`
        min-height: 20px;
        line-height: 20px;
        font-size: 14px;
      `;
    case 'large':
      return css`
        min-height: 32px;
        line-height: 32px;
        font-size: 15px;
      `;
    default:
      return css`
        min-height: 28px;
        line-height: 28px;
        font-size: 14px;
      `;
  }
};

const sizeMap = {
  small: 'small',
  default: 'middle',
  large: 'large',
} as const;

export const Segemented = forwardRef<
  HTMLDivElement,
  SegmentedProps & {
    size?: 'small' | 'default' | 'large';
  }
>((props, ref) => {
  return (
    <AntdSegmented
      {...props}
      className={css`
        &&& .ant-segmented-group {
          height: 100%;
          align-items: center;
        }
        &&& .ant-segmented-item-label {
          ${getStyle(props.size)}
        }
      `}
      size={props.size ? sizeMap[props.size] : 'middle'}
      ref={ref}
      style={{
        height: getHeight(props.size),
        ...props.style,
      }}
    />
  );
});
